// Sticky top announcement bar advertising the weekly ₹5000 free service prize.
// Dismissible per session.
import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { trackSpinStarted } from "@/lib/pixel";

const STORAGE_KEY = "ahq_promo_dismissed_v1";

const scrollTo = (id) =>
  document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });

export default function PromoBanner() {
  const [open, setOpen] = useState(() => {
    try {
      return sessionStorage.getItem(STORAGE_KEY) !== "1";
    } catch {
      return true;
    }
  });

  const dismiss = (e) => {
    e.stopPropagation();
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch { /* noop */ }
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ y: -40, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: -40, opacity: 0 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="sticky top-0 z-50 w-full bg-[#0A0A0A] text-white"
          data-testid="promo-banner"
        >
          <button
            type="button"
            onClick={() => { trackSpinStarted({ source: "promo_banner" }); scrollTo("spin"); }}
            data-testid="promo-banner-cta"
            className="w-full flex items-center justify-center gap-2 sm:gap-3 px-4 py-2.5 text-[11px] sm:text-xs uppercase tracking-[0.18em] font-semibold hover:bg-[#1a1a1a] transition-colors"
          >
            <span
              aria-hidden="true"
              className="inline-block w-1.5 h-1.5 rounded-full bg-[#D4AF37] animate-pulse"
            />
            <span className="text-[#D4AF37]">Spin &amp; Win</span>
            <span className="hidden sm:inline text-white/80">a chance to get</span>
            <span className="sm:hidden text-white/80">·</span>
            <span className="text-white font-bold">FREE Car Service worth ₹5,000</span>
            <span
              aria-hidden="true"
              className="ml-1 inline-block transition-transform group-hover:translate-x-0.5"
            >
              →
            </span>
          </button>
          <button
            type="button"
            onClick={dismiss}
            data-testid="promo-banner-close"
            aria-label="Dismiss announcement"
            className="absolute right-2 top-1/2 -translate-y-1/2 text-white/60 hover:text-white text-sm leading-none p-1"
          >
            ×
          </button>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
